import { generatePath, useHistory, useRouteMatch } from "react-router-dom"

export interface IUpdatePathParamsParams {
  [paramName: string]: string | number | boolean | undefined
}
interface IUseUpdatePathParamsParams {
  generateMergedPath: (updatedParams: IUpdatePathParamsParams) => string
  updatePathParams: (updatedParams: IUpdatePathParamsParams) => void
}

export default function useUpdatePathParams(): IUseUpdatePathParamsParams {
  const history = useHistory()
  const { path, params } = useRouteMatch()

  const generateMergedPath = (updatedParams: IUpdatePathParamsParams) => {
    const mergedParams = {
      ...params,
      ...updatedParams,
    }
    return generatePath(path, mergedParams)
  }

  const handleUpdatePathParams = (updatedParams: IUpdatePathParamsParams) =>
    history.push(generateMergedPath(updatedParams))

  return {
    updatePathParams: handleUpdatePathParams,
    generateMergedPath,
  }
}
